import request from '@/utils/request'
// 列表查询
export function getProTeacherKindergartenListData (params) {
  return request({
    url: 'users/pro_teachers/kindergartens/',
    method: 'get',
    params
  })
}

// 添加教师与专家绑定
export function addProTeacherKindergartenData (data) {
  return request({
    url: `users/pro_teachers/kindergartens/`,
    method: 'post',
    data,
    transformRequest: [
      function (data) {
        let ret = ''
        for (const it in data) {
          if (data[it]) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 删除教师与专家绑定
export function deleteProTeacherKindergartenData (id) {
  return request({
    url: `users/pro_teachers/kindergartens/${id}/`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/pro-teacher-kindergarten.js